import { useMutation } from '@apollo/client';
// Api
import { REMOVE_NOTIFICATIONS } from 'api/notifications/mutations';
import apolloNotificationClient from 'api/apolloNotificationClient';
// Types
import {
  RemoveNotifications,
  RemoveNotificationsVariables,
} from 'api/notifications/types/RemoveNotifications';
// Components
import { showToast } from 'components/common/Toast/Toast';

export const useRemoveNotification = () => {
  const [mutate] = useMutation<
    RemoveNotifications,
    RemoveNotificationsVariables
  >(REMOVE_NOTIFICATIONS, {
    client: apolloNotificationClient,
  });

  const removeNotification = async (ids: string[] | string): Promise<void> => {
    try {
      await mutate({
        variables: {
          input: {
            ids: Array.isArray(ids) ? ids : [ids],
          },
        },
      });
    } catch (error) {
      showToast({
        message:
          (error as Error).message ||
          'Error clearing notification. Refresh or try again later.',
        type: 'error',
      });
    }
  };

  return { removeNotification };
};
